import styled, { injectGlobal } from "styled-components";
import Modal from "react-modal";

import { colors, fonts } from "./theme";
import UnstyledButton from "./UnstyledButton";

Modal.defaultStyles = {
  overlay: {},
  content: {},
};

const ANIMATION_DURATION = 300;

injectGlobal`
  .ReactModal__Body--open {
    overflow: hidden;
  }

  .ReactModal__Overlay,
  .ContentViewer__Overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
    background: rgba(0, 0, 0, 0.64);
  }

  .ReactModal__Content {
    position: absolute;
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    overflow: auto;
    outline: none;
    font-size: 17px;
    line-height: 24px;
    letter-spacing: 0;
    -webkit-overflow-scrolling: touch;
  }

  .ContentViewer__Overlay {
    background: rgba(0, 0, 0, 0.8);
  }

  .ContentViewer__Content {
    pointer-events: none;
    position: relative;
    margin: 0 auto;
    /* max-width: 800px; */
    /* width: 90%; */
    width: 100%;
    min-height: 100%;
    outline: none;
  }

  /* animations */
  .ReactModal__Overlay,
  .ContentViewer__Overlay {
    opacity: 0;
  }

  .ReactModal__Overlay--after-open,
  .ContentViewer__Overlay--after-open {
    opacity: 1;
    transition: opacity ${ANIMATION_DURATION}ms ease-out;
  }

  .ReactModal__Content,
  .ContentViewer__Content {
  }

  .ReactModal__Content--after-open,
  .ContentViewer__Content--after-open {
    transition: all ${ANIMATION_DURATION}ms ease-in;
  }

  .ReactModal__Overlay--before-close,
  .ContentViewer__Overlay--before-close {
    opacity: 0;
  }

  .ReactModal__Content--after-close,
  .ContentViewer__Content--after-close {
    transition: all ${ANIMATION_DURATION}ms ease-in;
  }

  /* used for detail view */
  .FakeModal__Overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    overflow-y: auto;
  }

  .FakeModal__Content {
    width: 100vw;
    overflow: hidden;
    outline: none;
    pointer-events: none;
    -webkit-overflow-scrolling: touch;
  }
`;

export const Box = styled.div`
  border: 1px solid ${colors.modalBorderGray};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  background: ${colors.modalGray};
  color: rgba(255, 255, 255, 0.8);
  font-family: ${fonts.book};
`;

export const ButtonContainer = styled.div`
  display: flex;
`;

export const Button = UnstyledButton.extend`
  width: 100%;
  padding: 19px;
  font-family: ${fonts.book};
  font-size: 14px;
  letter-spacing: 2px;
  text-align: center;
  text-transform: uppercase;
  background: transparent;
  color: ${props => {
    switch (props.type) {
      case "danger":
        return colors.red;
      case "primary":
        return colors.primary;
      default:
        return colors.white;
    }
  }};
  border-top: 1px solid ${colors.modalBorderGray};
  border-right: 1px solid ${colors.modalBorderGray};

  &:last-child {
    border-right: 0;
  }

  &:hover,
  &:focus {
    background: ${colors.moonLight};
    outline: none;
  }

  &:disabled {
    opacity: 0.5;
  }
`;

export const Title = styled.div`
  font-family: ${fonts.medium};
  font-size: 22px;
  text-align: center;
  padding-bottom: 21px;
`;

export const SectionTitle = styled.div`
  font-family: ${fonts.book};
  font-size: 14px;
  line-height: 1;
  margin-bottom: 11px;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: 2px;
  text-transform: uppercase;
`;

Modal.defaultProps = {
  ...Modal.defaultProps,
  closeTimeoutMS: ANIMATION_DURATION,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js